import React from 'react';
import packagesData from '../data/package.json';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, Grid, Card, CardMedia, Paper } from '@mui/material';

const Packages = () => {
    const navigate = useNavigate();

    return (
        <Box p={4}>
            <Typography variant="h4" fontWeight="bold" mb={5}>Trending Destinations</Typography>
            <Grid container spacing={8}>
                {packagesData.map(dest => (
                    <Grid item xs={12} sm={6} md={4} key={dest.id}>
                        <Card sx={{ position: 'relative', overflow: 'visible', boxShadow: 3, cursor: 'pointer' }}
                            onClick={() => navigate(`/packages/${dest.id}`)}>
                            {/* Image */}
                            <Box
                                sx={{
                                    overflow: 'hidden',
                                    borderTopLeftRadius: 8,
                                    borderTopRightRadius: 8,
                                    border: "1px solid black",
                                    '& img': {
                                        transition: 'transform 0.5s ease',
                                    },
                                    '&:hover img': {
                                        transform: 'scale(1.08)',
                                    },
                                }}
                            >
                                <CardMedia
                                    component="img"
                                    sx={{
                                        height: 200, // Set your desired fixed height here
                                        width: 300,
                                        objectFit: 'cover', // or "contain" if you want full image visible with possible empty space
                                    }}
                                    image={dest.image}
                                    alt={dest.name}
                                />
                            </Box>

                            {/* Overlapping White Box */}
                            <Paper
                                elevation={3}
                                sx={{
                                    position: 'absolute',
                                    bottom: -20,
                                    left: '50%',
                                    transform: 'translateX(-50%)',
                                    width: '75%',
                                    backgroundColor: '#fff',
                                    borderRadius: 5,
                                    p: 1,
                                    textAlign: 'center',
                                    zIndex: 1,
                                    color: "black",
                                    fontWeight : "bold"
                                }}
                            >
                                <Typography variant="body2">{dest.location}</Typography>
                            </Paper>
                        </Card>

                    </Grid>
                ))}
            </Grid>
        </Box>
    );
};

export default Packages;
